<template>
  <svg width="20" height="20" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <g clip-path="url(#clip1)">
        <path d="M16 15.3332C16 15.7012 15.7013 15.9998 15.3333 15.9998L0.666667 15.9998C0.298667 15.9998 0 15.7012 0 15.3332C0 14.9652 0.298667 14.6665 0.666667 14.6665L15.3333 14.6665C15.7013 14.6665 16 14.9652 16 15.3332Z" fill="#292929"/>
        <path d="M3.3335 6L8.00016 12L12.6668 6L8.66683 6L8.66683 0.666667C8.66683 0.298 8.36883 0 8.00016 0C7.6315 0 7.3335 0.298 7.3335 0.666667L7.3335 6L3.3335 6Z" fill="#292929"/>
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
      <clipPath id="clip1">
        <rect width="15" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'download-svg'
}
</script>
<style scoped>
svg path, svg rect {
	fill: var(--secondary-bg-text);
}
svg path:hover, svg rect:hover {
  fill: var(--button-hover-bg-text);
}
</style>
